<template>
    <div class="modal fade" :id="modalId" tabindex="-1" role="dialog"
         aria-labelledby="companyModalLabel" aria-hidden="true" ref="modal">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id="companyModalLabel">{{ title }}</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <CompanyEditor ref="companyEditor" @interface="companyUpdated" :company="company"/>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
  export default {
    name: 'CompanyEditorModal',
    props: {
      modalId: {
        type: String,
        required: false,
        default: 'companyModal',
      },
      company: {
        type: Object,
        required: false,
        default: () => {},
      },
    },
    computed: {
      title() {
        if (this.company.hasOwnProperty('id')) {
          return 'Edit Company & Contact';
        }
        return 'Create Company & Contact';
      },
    },
    mounted() {
      $(this.$refs.modal).on("hidden.bs.modal", this.onHide)
    },
    beforeDestroy() {
      $(this.$refs.modal).off("hidden.bs.modal", this.onHide)
    },
    methods: {
      companyUpdated(company) {
        this.$emit('interface', company);
      },
      onHide() {
        this.$refs.companyEditor.form.reset();
      },
    },
  };
</script>
